import React, { useState, useEffect } from "react";
import LeftSidebar from "./LeftSidebar/LeftSidebar";
import MiddleContent from "./MiddlePanel/MiddleContent";
import RightSidebar from "./RightPanel/RightSidebar";
import { fetchJobStatusSummary } from "../api/candidateApi";
import "./DashboardContent.css";
import GlobalDateFilter from "./GlobalDateFilter";


function DashboardContent({ candidateId, employeeId }) {
  const [dateFilter, setDateFilter] = useState("today");
  const [summary, setSummary] = useState(null);
  const [activeStatus, setActiveStatus] = useState("HOME");

  async function refreshSummary() {
    try {
      const res = await fetchJobStatusSummary(candidateId, dateFilter);
      setSummary({ ...res.data });
    } catch (err) {
      console.error("Error refreshing summary:", err);
    }
  }


  function isDateAllowed(dateFilter) {

    // TODAY and YESTERDAY are always safe
    if (dateFilter === "today" || dateFilter === "yesterday") {
      return true;
    }

    // CUSTOM DATE VALIDATION
    const selected = new Date(dateFilter);
    const today = new Date();

    const fourDaysAgo = new Date();
    fourDaysAgo.setDate(today.getDate() - 4);

    // Normalize times
    selected.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    fourDaysAgo.setHours(0, 0, 0, 0);

    return selected >= fourDaysAgo;
  }

  useEffect(() => {
    if (!isDateAllowed(dateFilter)) {
      alert("Only last 4 days of job data are available. Please use Reports page for older data.");
      return;
    }
    fetchJobStatusSummary(candidateId, dateFilter)
      .then(res => setSummary({ ...res.data })) // <--- FORCE NEW REFERENCE
      .catch(err => console.error("Summary error:", err));
  }, [candidateId, dateFilter]);

  return (
    <div className="dashboard-wrapper">

      {/* ⭐ GLOBAL DATE FILTER HERE */}
      <GlobalDateFilter dateFilter={dateFilter} setDateFilter={setDateFilter} />
      <div className="dashboard-3panel">
        <LeftSidebar summary={summary} activeStatus={activeStatus} setActiveStatus={setActiveStatus} />
        <MiddleContent candidateId={candidateId} activeStatus={activeStatus} employeeId={employeeId} 
        dateFilter={dateFilter}    refreshSummary={refreshSummary}
        />
        <RightSidebar candidateId={candidateId} />
      </div>
    </div>
  );
}

export default DashboardContent;
